
import React from 'react';
import HrWithText from 'components/HrWithText';

import InfoText from './Content/InfoText';
import {PackageListMobile} from './Content/PackageList';
import PackageSlider from './Content/PackageSlider';
import PriceButton from './Content/PriceButton';

import * as styles from './styles.module.scss';

const MobileCustom = () => {
	return (
		<>
			<p>
				Not ready to commit? Come see the
				value of your data firsthand!
			</p>
			<PriceButton center>
				1 baseline scan
			</PriceButton>
			<HrWithText className={styles.customOr}>
				or
			</HrWithText>
			<h2 className={styles.customH2}>
				Customize our service
			</h2>
			<PackageListMobile />
			<PackageSlider center />
			<InfoText.Custom />
		</>
	);
};

export default MobileCustom;
